<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Reporte Cancelación Cuenta con Cuota en Viaje</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <span class="title">Filtros</span>
        <v-divider></v-divider>
        <v-row dense>
            <v-col cols="12" lg="3">
                <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                    item-text="nombre" item-value="id" label="Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="3">
                <v-autocomplete v-model="filtro.sucursalId" :items="listSucursales" autocomplete="disabled"
                    item-text="nombre" item-value="id" label="de la Sucursal" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="3">
                <v-autocomplete v-model="filtro.canalVentaId" :items="listCanalesVenta" autocomplete="disabled"
                    item-text="nombre" item-value="id" label="del Canal de Venta" placeholder="Seleccione uno" :menu-props="{ minWidth: '400' }"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="3">
                <v-text-field v-model="filtro.fechaDesde" label="Fecha Desde" type="date" prepend-icon="event"></v-text-field>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn dark color="green" @click="procesarReporte">
          Generar Reporte&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 1,
        sucursalId: 0,
        canalVentaId: 0,
        fechaDesde: null,
      },
      listEmpresas: [],
      listSucursales: [],
      listCanalesVenta: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
    this.loadCanalesVenta();

  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );
        this.listEmpresas = result.list;
        this.listEmpresas.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?usuarioId=' + this.user.id
        );

        this.listCanalesVenta = result.list;
        this.listCanalesVenta.unshift({id:0,nombre:'(Todos)'});
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.listSucursales = result.list;

        this.listSucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validar() {
      return true;
    },
    async procesarReporte() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      console.log(this.filtro.empresaId);
      console.log(this.filtro.sucursalId);
      console.log(this.filtro.canalVentaId);
      console.log(this.filtro.fechaDesde);

      try {
        self.loading = true;

        let params = [];
        params.push({
          Version: this.$store.state.version,
          EmpresaId: this.filtro.empresaId,
          SucursalId: this.filtro.sucursalId,
          CanalVentaId: this.filtro.canalVentaId,   
          FechaDesde: this.filtro.fechaDesde || null,
        });

        this.setReporteActivo({
          reporte: "ReporteCancelacionCuotaEnViaje.trdp",
          params: params,
        });
        window.open("/report-viewer");
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>
